module.exports = __webpack_public_path__ + "media/images/products/category/service-e3daf9f136a269520c9cc8b746b333a3.jpg";